module.exports = __webpack_public_path__ + "img/12_76.67305667.png";